(() => {
  'use strict';
  const reduce = matchMedia('(prefers-reduced-motion: reduce)');
  const mobile = matchMedia('(max-width: 760px) and (min-height: 651px)');
  const stacks = new Map();
  let frame = 0;
  function reset(state) { state.cards.forEach(card => card.style.removeProperty('transform')); }
  function paint() {
    frame = 0;
    const jobs = [];
    for (const state of stacks.values()) {
      if (!state.visible || reduce.matches || !mobile.matches) continue;
      const rects = state.cards.map(card => card.getBoundingClientRect());
      state.cards.forEach((card, i) => {
        const next = rects[i + 1];
        const top = 95 + i * 10;
        const covered = next ? Math.max(0, Math.min(1, (top + rects[i].height - next.top) / rects[i].height)) : 0;
        const angle = i % 2 ? 1.5 : -1.5;
        jobs.push(() => { card.style.transform = `translateY(${-covered * 5}px) rotate(${angle * (1 - covered * .65)}deg) scale(${1 - covered * .055})`; });
      });
    }
    jobs.forEach(job => job());
  }
  function schedule() {
    if (document.hidden || frame || reduce.matches || !mobile.matches) return;
    if ([...stacks.values()].some(state => state.visible)) frame = requestAnimationFrame(paint);
  }
  function setup(scope = document) {
    scope.querySelectorAll('[data-af-secondary]').forEach(image => {
      if (image.dataset.afBound) return;
      image.dataset.afBound = 'true';
      const showAlternate = () => image.parentElement.classList.toggle('has-alternate-ready', image.naturalWidth > 0);
      image.addEventListener('load', showAlternate);
      image.addEventListener('error', () => image.parentElement.classList.remove('has-alternate-ready'));
      if (image.complete) showAlternate();
    });
    scope.querySelectorAll('[data-af-release-stack]').forEach(root => {
      if (stacks.has(root)) return;
      const state = { cards: [...root.querySelectorAll('.af-release')], visible: true, observer: null };
      if ('IntersectionObserver' in window) {
        state.observer = new IntersectionObserver(([entry]) => {
          state.visible = entry.isIntersecting;
          if (state.visible) schedule();
        }, { rootMargin: '100px' });
        state.observer.observe(root);
      }
      stacks.set(root, state);
    });
    schedule();
  }
  function preferenceChanged() { stacks.forEach(reset); schedule(); }
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', preferenceChanged, { passive: true });
  reduce.addEventListener('change', preferenceChanged);
  mobile.addEventListener('change', preferenceChanged);
  document.addEventListener('visibilitychange', () => { if (document.hidden) { cancelAnimationFrame(frame); frame = 0; } else schedule(); });
  document.addEventListener('shopify:section:load', event => setup(event.target));
  document.addEventListener('shopify:section:unload', event => { for (const [root, state] of stacks) if (event.target.contains(root)) { state.observer?.disconnect(); reset(state); stacks.delete(root); } });
  // Keyboard users get the complete, unobstructed sleeve they focused.
  document.addEventListener('focusin', event => { if (event.target.closest?.('[data-af-release-stack]')) { for (const state of stacks.values()) reset(state); } });
  setup();
})();
